import React, { useState, useEffect } from "react";
import "@styles/pages/Login/Password/ForgetPassword.scss";
import { Box, Typography, TextField, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Trans, useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { forgetPassword } from "@api/authenticationApi";
import { toast } from "react-toastify";

const ForgetPassword = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const forgetPasswordRequest = async () => {
    const finalData = {
      email,
    };
    setIsLoading(true);
    try {
      const res = await forgetPassword(finalData);
      const data = res.data.Data;
      const statusCode = res.data.StatusCode;
      switch (statusCode) {
        case 200:
          setIsSend(true);
          break;
        case 306:
          toast.error(t("status_message:status_code_306"));
          break;
        case 309:
          toast.error(t("status_message:status_code_309"));
          break;
        case 500:
          toast.error(t("status_message:status_code_500"));
          break;
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box className="forget-password-container">
      <Box className="forget-password-detail-container">
        <Box className="text-container">
          <Typography className="title">
            <Trans i18nKey="login:forget_password" />?
          </Typography>
          <Typography className="description">
            <Trans i18nKey="login:reset_password_description" />
          </Typography>
        </Box>
        {isSend ? (
          <Typography className="check-email">
            <Trans i18nKey="login:check_email" />
          </Typography>
        ) : (
          <>
            <Box className="field-container">
              <Typography>
                <Trans i18nKey="login:email" />
              </Typography>

              <TextField
                fullWidth
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Box>
            <Box className="button-container">
              <LoadingButton
                fullWidth
                className="loading-button"
                disabled={isLoading}
                loading={isLoading}
                onClick={forgetPasswordRequest}
              >
                <Trans i18nKey="login:reset_password" />
              </LoadingButton>
            </Box>
          </>
        )}

        <Typography
          className="back-icon-container"
          onClick={() => {
            navigate("/login");
          }}
        >
          <ArrowBackIcon className="back-icon" />{" "}
          <Trans i18nKey="login:back_to_login" />
        </Typography>
      </Box>
    </Box>
  );
};

export default ForgetPassword;
